/** Catalog payer codes look like `MX_BANCO_AZTECA`, not a bank's display name. */
export function looksLikePayerCode(value: string): boolean {
  return /^[A-Z]{2}_[A-Z0-9_]+$/.test(value.trim().toUpperCase());
}

/**
 * Name to show on a bank-account row. Keeps the stored string as-is.
 * A routing code is skipped so the catalog name can be used instead.
 */
export function bankAccountDisplayName(
  stored: string | null | undefined,
  catalogName?: string | null,
): string | null {
  const name = stored?.trim();
  if (name && !looksLikePayerCode(name)) return name;
  const catalog = catalogName?.trim();
  return catalog || null;
}

/**
 * Bank-account row: stored name plus the last four digits.
 * The name is not recased. Returns null when there is no name.
 */
/**
 * Visible bank-account line. Named rows are `NAME *1234`.
 * Without a name, the caller supplies the generic copy.
 */
export function bankAccountRowLabel(input: {
  stored?: string | null;
  catalogName?: string | null;
  accountOrLast4?: string | null;
  unnamedWithDigits: string;
  empty: string;
}): string {
  const digits = (input.accountOrLast4 ?? "").replace(/\D/g, "").slice(-4);
  const name = bankAccountDisplayName(input.stored, input.catalogName);
  const line = formatBankAccountLabel(name, digits);
  if (line) return line;
  if (digits) return input.unnamedWithDigits;
  return input.empty;
}

export function formatBankAccountLabel(
  name: string | null | undefined,
  accountOrLast4: string | null | undefined,
): string | null {
  const bank = name?.trim();
  if (!bank) return null;
  const last4 = (accountOrLast4 ?? "").replace(/\D/g, "").slice(-4);
  return last4 ? `${bank} *${last4}` : bank;
}
